import { useCallback, useEffect, useState } from 'react';

interface UseCountdownOptions {
  initialSeconds: number;
  onComplete?: () => void;
  enabled?: boolean;
}

export const useCountdown = ({
  initialSeconds,
  onComplete,
  enabled = true,
}: UseCountdownOptions): {
  seconds: number;
  isComplete: boolean;
  reset: () => void;
} => {
  const [seconds, setSeconds] = useState(initialSeconds);
  const isComplete = seconds === 0;

  useEffect(() => {
    if (!enabled || isComplete) return;

    const timer = setInterval(() => {
      setSeconds((prev) => {
        if (prev <= 1) {
          onComplete?.();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return (): void => clearInterval(timer);
  }, [enabled, isComplete, onComplete]);

  const reset = useCallback((): void => {
    setSeconds(initialSeconds);
  }, [initialSeconds]);

  return {
    seconds,
    isComplete,
    reset,
  };
};
